import Translation from '../../../../translation/translation';

function MobileFittingServices(props) {
    if (!props.isMobileFitter) {
        return null;
    }

    return (
        <div className="fsf-station__detail">
            <h3 className="fsf-station__detail-headline">
                <Translation translationKey="fitting-station-finder-app-mobile-fitter" />
            </h3>
            <div className="fsf-station__detail-contents">
                <p>
                    <Translation translationKey="fitting-station-finder-app-mobile-fitter-contact" />
                </p>
            </div>
        </div>
    );
}

export default MobileFittingServices;
